const MarketplaceTopBar = ({ categories, selectedCategory, onCategory, onSearchInputChange }) => {
  const onInputChange = event => {
    onSearchInputChange(event.target.value);
  };

  return (
    <div className="marketplace__topbar">
      <div className="marketplace__topbar__category">
        {categories?.length &&
          categories.map(category => {
            return (
              <div
                key={category?.short_name}
                className={`marketplace__topbar__category-item ${
                  category?.short_name === selectedCategory?.short_name ? "selected-item" : ""
                }`}
                onClick={() => onCategory(category)}
              >
                {category?.display_name}
              </div>
            );
          })}
      </div>
      <div className="marketplace__topbar__search">
        <div className="input__wrapper">
          <input
            id="search__offer__input"
            className="input__field"
            placeholder="Type to search..."
            onChange={onInputChange}
          />
        </div>
      </div>
    </div>
  );
};

export default MarketplaceTopBar;
